import { Modal, Button } from "react-bootstrap";
import React from "react";
import "../modal.css";
import "react-datepicker/dist/react-datepicker.css";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import { useFormik } from "formik";
import * as Yup from "yup";
const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/
const basicSchema = Yup.object().shape({
  perm_name: Yup.string().required("Permission name is required"),
  perm_description: Yup.string().required("Description  is required"),
 

  //phoneNumber: Yup.string().matches(phoneRegExp, 'Phone number is not valid').required()
});

const Add = ({ showModal, hideModal }) => {
  const history = useNavigate();

  const onSubmit = async (values, actions) => {

    await new Promise((resolve) => setTimeout(resolve, 1000));
    addDriver(values);
  };

  const { values,
    errors,
    touched,
    isSubmitting,
    setFieldValue,
    handleBlur,
    handleChange,
    handleSubmit, submitForm } = useFormik({
      initialValues: {
        perm_name: "",
        perm_description: '',
       

      },
      validationSchema: basicSchema,
      onSubmit
    })

  const DatePickerField = ({ name, value, onChange }) => {
    return (
      <DatePicker
        selected={(value && new Date(value)) || null}
        onChange={val => {
          onChange(name, val);
        }}
      />
    );
  };
  const notifySuccess = () => toast.success('Driver Added.', {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const notifyError = () => toast.error('Something went wrong ...', {
    position: "top-right",
    autoClose: 1000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

  const addDriver = async (e) => {

    try {

      const bodyFormData = new FormData();
      for (let value in values) {
        bodyFormData.append(value, values[value]);
      }
      const responce = await axios.post("/permissions", bodyFormData);
      history("/permissions");
      hideModal();
      notifySuccess();
      console.log(responce.status)
    } catch (error) {
      console.log(error.response)
      if (error.response) {
        notifyError();
      }
    }
  };


  return (


    <form onSubmit={handleSubmit} autoComplete="off" encType="multipart/form-data">
      <Modal
      style={{marginTop: "60px"}}
        show={showModal}
        onHide={hideModal}
        backdrop={false}
        contentClassName="custom-modal-style"
      >

        <Modal.Header closeButton>
          <Modal.Title>Add Permission</Modal.Title>
        </Modal.Header>
        <Modal.Body
        >

          <div class="row" >
            <div class="col-md-12">
              <div class="card card-primary">

                <div class="card-body">
                  <div class="form-group">
                    <label for="inputName">Permission Name</label>
                    <input
                      type="text"
                      name="perm_name"
                      value={values.perm_name}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.perm_name && touched.perm_name ? "form-control input-error" : "form-control "}

                    />
                    {errors.perm_name && touched.perm_name && <p className="error">{errors.perm_name}</p>}

                  </div>

                  <div class="form-group">
                    <label for="inputName">Description</label>
                    <input
                      type="text"
                      name="perm_description"
                      value={values.perm_description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={errors.perm_description && touched.perm_description ? "form-control input-error" : "form-control "}

                    />
                    {errors.perm_description && touched.perm_description && <p className="error">{errors.perm_description}</p>}

                  </div>

        

                </div>
              </div>
            </div>
         
          </div>

        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={hideModal}>
            Cancel
          </Button>

          <button disabled={isSubmitting} onClick={submitForm} className="btn btn-success" type="submit">
            Submit
          </button>

        </Modal.Footer>

      </Modal>
    </form>

  );
};

export default Add;
